document.querySelectorAll('.product-card').forEach(function(card){

    const buttons = card.querySelectorAll('.swatches button');
    const price = card.querySelector('.product-price');
    const addBtn = card.querySelector('.add-to-cart');

    // Variant selection
    buttons.forEach(function(button){

        button.addEventListener('click', function(){

            buttons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            // Update price
            price.textContent = this.dataset.price;

            // Store selected variant
            addBtn.setAttribute('variant-id', this.dataset.variantId);

        });

    });

    // Add to cart
    addBtn.addEventListener('click', async function(e){
        e.preventDefault();
        const variantId = this.getAttribute('variant-id');
        if (!variantId) return;
        this.disabled = true;
        const originalText = this.innerHTML;
        this.innerHTML = '<i class="fa-solid fa-spinner fa-spin mr-2"></i>Adding...';
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: Number(variantId),
                        quantity: 1
                    }],
                    sections: ['cart-drawer','cart-icon-bubble'],
                    sections_url: window.location.pathname
                })
            });

            const result = await response.json();
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && result.sections) {
                cartDrawer.classList.remove('is-empty');
                cartDrawer.renderContents({
                    id: result.items?.[0]?.id || result.id,
                    sections: result.sections,
                    item_count: result.items?.length || 1
                });
            } else {
                // Theme doesn't support drawer
                window.location.href = '/cart';
            }

        } catch(error) {
            console.error(error);
            // Fallback
            window.location.href = '/cart/' + variantId + ':1';
        } finally {
            this.disabled = false;
            this.innerHTML = originalText;
        }

    });

});